import { ContactSupport, InfoOutlined } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useCallback } from 'react';
import { Cafe } from '../../apiTypes';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';
import { updateDoc } from '../../utils/api';
import useMedia from '../../utils/useMedia';

const InitialMessage = () => {
  const { lang } = useLocale();
  const { cafeSlug } = useAdmin();
  const { setOpenMessages } = useCafe();
  const { isSm } = useMedia();

  const handleClose = useCallback(async () => {
    updateDoc<Cafe>(`cafes/${cafeSlug}`, {
      'messages.initial': true,
    });
    setOpenMessages(true);
  }, [cafeSlug, setOpenMessages]);

  return (
    <Dialog open fullScreen={isSm} onClose={handleClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>{t.welcome_to_firemenu_world[lang]}</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2, mt: 2, lineHeight: '26px' }}>{t.chosen_recipe[lang]}</Typography>
        <Typography sx={{ lineHeight: '26px' }}>{t.before_you_dive[lang]}</Typography>

        <Typography component="ul" sx={{ mb: 4, mt: 2, lineHeight: '26px', li: { mb: 2 } }}>
          <li>
            <span>{t.loyal_assistants[lang]}</span>
            <InfoOutlined fontSize="small" color="action" />
            <span>{t.loyal_assistants2[lang]}</span>
          </li>
          <li>
            <span>{t.encountered_obstacle[lang]}</span>
            <ContactSupport fontSize="small" color="action" />
            <span>{t.encountered_obstacle2[lang]}</span>
          </li>
          <li>{t.next_step[lang]}</li>
          <li>{t.open_to_suggestions[lang]}</li>
        </Typography>

        <Typography>{t.best_wishes[lang]}</Typography>
        <Typography>{t.firemenu_team[lang]}</Typography>

        <DialogActions>
          <PrimaryButton onClick={handleClose}>{t.lets_go[lang]}</PrimaryButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default InitialMessage;
